import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Auth/Login';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import Layout from './components/Layout/Layout';
import AgentDashboard from './pages/Agent/AgentDashboard';
import TeamLeadDashboard from './pages/TeamLead/TeamLeadDashboard';
import ManagerDashboard from './pages/Manager/ManagerDashboard';
import TicketDetailPage from './pages/Agent/TicketDetailPage';
import ManageAgents from './pages/Manager/ManageAgents'; // ✅ ADD THIS
import { ROLES } from './utils/constants';
import './styles/global.css';
import AnalyticsDashboard from './pages/Analytics/AnalyticsDashboard'; 
function DashboardRouter() {
  const { user } = useAuth();

  if (user?.role === ROLES.MANAGER) return <ManagerDashboard />;
  if (user?.role === ROLES.TEAM_LEAD) return <TeamLeadDashboard />;
  return <AgentDashboard />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<DashboardRouter />} />
            <Route path="my-tickets" element={<AgentDashboard />} />
            <Route path="ticket/:id" element={<TicketDetailPage />} />
            <Route path="team-tickets" element={<TeamLeadDashboard />} />
            <Route path="all-tickets" element={<ManagerDashboard />} />
            <Route path="manage-agents" element={<ManageAgents />} /> {/* ✅ ADD THIS */}
            <Route path="analytics" element={<AnalyticsDashboard />} />

            <Route path="" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
